import { useMemo } from "react";

import debounce from "@utils/debounce";

type TWrappedFunction = (...args: any[]) => any;

interface IDebouncedFunction<F extends TWrappedFunction> {
  (...args: Parameters<F>): Promise<ReturnType<F>>;
}

const useDebounce = <T extends TWrappedFunction>(callback: T): IDebouncedFunction<T> => {
  const debouncedFunction = useMemo(() => debounce(callback), [callback]);
  return debouncedFunction;
};

export default useDebounce;
